import React from "react";
import { timeZoneLabel } from "../timeZones";

const viewLabels = { timeGridWeek: "Week", timeGridDay: "Day", dayGridMonth: "Month", listWeek: "List" };

export default function CalendarToolbar({ title, date, timeZone, timeZoneControl, viewType, views, onNavigate, onViewChange, onDateChange }) {
  const period = (viewLabels[viewType] || "period").toLowerCase();
  return <div className="schedule-calendar-toolbar">
    <div className="schedule-calendar-period">
      <div className="schedule-calendar-arrows">
        <button type="button" aria-label={`Previous ${period}`} onClick={() => onNavigate("prev")}>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m14 6-6 6 6 6" /></svg>
        </button>
        <label className="schedule-calendar-jump"><span>Go to date</span><input type="date" value={date} onChange={(e) => { if (e.target.value) onDateChange(e.target.value); }} /></label>
        <button type="button" aria-label={`Next ${period}`} onClick={() => onNavigate("next")}>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m10 6 6 6-6 6" /></svg>
        </button>
        <button type="button" className="schedule-calendar-today" onClick={() => onNavigate("today")}>Today</button>
      </div>
      <div className="schedule-calendar-heading"><h2 aria-live="polite">{title}</h2>{!timeZoneControl && <span>{timeZoneLabel(timeZone)} time</span>}</div>
    </div>
    <div className="schedule-calendar-tools">
      {timeZoneControl && React.cloneElement(timeZoneControl, { date })}
      <div className="schedule-calendar-view-switch" aria-label="Calendar view">
        {views.split(",").filter(Boolean).map((view) => <button key={view} type="button" aria-pressed={viewType === view}
          onClick={() => onViewChange(view)}>{viewLabels[view] || view}</button>)}
      </div>
    </div>
  </div>;
}
